module.exports = __webpack_public_path__ + "img/tempfile2.6c0ce4d7.png";